import { ISearch } from './ISearch.model';

export class ReportPdfModel implements ISearch {
  public id: string;
  public inspectionId: string;
  public generationDate: Date;
  public name: string;
  public status: number;
  public items: ReportItem[];
  public isNew: boolean;

  public search(query: string): boolean {
    return this.name != null && this.name.toLowerCase().indexOf(query) !== -1;
  }
}

export class ReportItem {
  public id: string;
  public generationDate: Date;
  public path: string;
  public name: string;
  public reportId: string;
  public status: number;
  public type: number;
}
